import { render, staticRenderFns } from "./EditorSimple.vue?vue&type=template&id=6da876c7&scoped=true&"
import script from "./EditorSimple.vue?vue&type=script&lang=js&"
export * from "./EditorSimple.vue?vue&type=script&lang=js&"
import style0 from "./EditorSimple.vue?vue&type=style&index=0&id=6da876c7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da876c7",
  null
  
)

export default component.exports